import React, { useEffect, useMemo } from "react";
import { Button, Descriptions, Drawer, Space, Tag, Typography } from "antd";
import { AppstoreOutlined, EditOutlined, LinkOutlined } from "@ant-design/icons";
import { formatEnumLabel } from "../constants";

export default function ServiceOfferingDetailsDrawer({
  open,
  onClose,
  offering,
  onEdit,
  onAttach,
}) {
  const title = useMemo(() => {
    if (!offering?.code && !offering?.name) return "Service Offering";
    return `${offering?.name || "Service"}${offering?.code ? ` (${offering.code})` : ""}`;
  }, [offering]);

  useEffect(() => {
    if (!open) return;
  }, [open]);

  return (
    <Drawer
      title={
        <Space>
          <span>{title}</span>
        </Space>
      }
      width={560}
      open={open}
      onClose={onClose}
      destroyOnClose
      placement="right"
      zIndex={2200}
      extra={
        <Space>
          <Button
            icon={<LinkOutlined />}
            disabled={!offering?.code}
            onClick={() => onAttach?.(offering)}
          >
            Attach
          </Button>
          <Button
            type="primary"
            icon={<EditOutlined />}
            disabled={!offering?.id}
            onClick={() => onEdit?.(offering)}
          >
            Edit
          </Button>
        </Space>
      }
      footer={
        <Space style={{ width: "100%", justifyContent: "flex-end" }}>
          <Button onClick={onClose}>Close</Button>
        </Space>
      }
    >
      <Descriptions
        bordered
        size="small"
        column={1}
        labelStyle={{ width: 170 }}
        contentStyle={{ background: "#fff" }}
      >
        <Descriptions.Item label="Code">
          <Typography.Text code>{offering?.code || "-"}</Typography.Text>
        </Descriptions.Item>
        <Descriptions.Item label="Name">{offering?.name || "-"}</Descriptions.Item>
        <Descriptions.Item label="Category">
          {offering?.category ? <Tag>{formatEnumLabel(offering.category)}</Tag> : "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Status">
          <Tag color={offering?.active ? "green" : "red"}>
            {offering?.active ? "ACTIVE" : "INACTIVE"}
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Description">
          {offering?.description || "-"}
        </Descriptions.Item>
      </Descriptions>
    </Drawer>
  );
}

